module.exports = __webpack_public_path__ + "img/emitFacebeauty01.e36ae12f.png";